var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaLibrary2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Media Library 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-34.000000, -7.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Media-Library",
    transform: "translate(35.585065, 8.114994)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    strokeWidth: 1.142,
    points: "8.84230149 9.49102538 5.37874228 11.5425686 5.43896254 7.3462037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    strokeWidth: 1.3,
    points: "0.0046506734 14.7015021 14.2267677 14.7015021 14.2267677 4.20359396 0.0046506734 4.20359396"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    strokeWidth: 1.3,
    points: "0.00494879349 3.00298354 0.00494879349 2.10168038 14.2270658 2.10168038 14.2270658 3.00298354"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    strokeWidth: 1.3,
    points: "0 0.901303155 0 0 14.2215208 0 14.2215208 0.901303155"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLibrary2);
export default __webpack_public_path__ + "static/media/Media Library 2.06c70b6ca289ef8f1d167006c2b7fa71.svg";
export { ForwardRef as ReactComponent };